import React from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"

const TableActionsColumn = ({ actions = [], rowElement }) => {
  return (
    <UncontrolledDropdown className="text-end">
      <DropdownToggle href="#" className="card-drop" tag="i">
        <i className="mdi mdi-dots-vertical font-size-18" />
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        {actions.map((a, index) => (
          <DropdownItem
            key={index}
            href="#"
            onClick={e => {
              e.preventDefault()
              a.onClick(rowElement)
            }}
            disabled={a?.isAvailable === false}
          >
            <i className={a.icon} /> {a.name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default TableActionsColumn
